module.exports = __webpack_public_path__ + "img/forgot-password.63f5a96a.png";